// Midnight Paddle Tennis - Menu Tooltips
// Tooltip text is managed via the theme editor (Header section settings)

document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.header__menu-item');
  
  menuItems.forEach(function(item) {
    const tooltipText = item.getAttribute('data-mpt-tooltip');
    
    if (tooltipText && tooltipText.trim() !== '') {
      item.style.position = 'relative';
      item.setAttribute('data-tooltip', tooltipText);
      
      const tooltip = document.createElement('span');
      tooltip.className = 'mpt-tooltip';
      tooltip.textContent = tooltipText;
      item.appendChild(tooltip);
    }
  });
});